import { AuthErrorCodes } from "firebase/auth";

export const AUTH_ERROR_MESSAGES = {
  [AuthErrorCodes.INTERNAL_ERROR]: "Unauthorized email.",
  [AuthErrorCodes.POPUP_CLOSED_BY_USER]:
    "Sign-in was cancelled. Please try again.",
  [AuthErrorCodes.EXPIRED_POPUP_REQUEST]:
    "Sign-in was cancelled. Please try again.",
  [AuthErrorCodes.POPUP_BLOCKED]:
    "The sign-in popup was blocked. Please allow popups and try again.",
  [AuthErrorCodes.NEED_CONFIRMATION]:
    "An account already exists with this email using a different sign-in method.",
  [AuthErrorCodes.USER_DISABLED]: "This account has been disabled.",
  [AuthErrorCodes.NETWORK_REQUEST_FAILED]:
    "Network error. Check your connection and try again.",
  [AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER]:
    "Too many attempts. Please try again later.",
  [AuthErrorCodes.INVALID_ORIGIN]: "This domain is not authorized for sign-in.",
  [AuthErrorCodes.OPERATION_NOT_ALLOWED]: "Microsoft sign-in is not enabled.",
};

